import { memo } from 'react';
import { FaRegCalendarAlt } from 'react-icons/fa';
import styled from 'styled-components';

import Image from 'src/components/image';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import { convertBadge, timeAgo, useDateUpdate } from 'src/utils/helper';

// const Image = dynamic(import('src/components/cards/image'));

const CardHSubscribe = ({ data, showBadge = true, showTitle = true, showBlurb = false, showTimeAgo = true, showPublishDate = false, showImage = true, external = false, eventDataLayer }) => {
  const conditionBadge = showBadge && convertBadge(data, false);

  return (
    <CardWrapper className='card-h-subscribe' showImage={showImage}>
      {showImage && (
        <CardImage className='img-scale-animate'>
          <a
            href={data?.link}
            title={data?.title}
            target='_self'
            tabIndex={-1}
            // ! DATALAYER
            onClick={() =>
              sendDataLayerGlobal({
                ...eventDataLayer
              })
            }
          >
            <Image image={data?.image || '/default.jpg'} title={data?.title || 'card-h'} external={external} />
          </a>
        </CardImage>
      )}
      <CardContent
        title={data?.title}
        tabIndex={-1}
        href={data?.link}
        target='_self'
        // ! DATALAYER
        onClick={() =>
          sendDataLayerGlobal({
            ...eventDataLayer
          })
        }
      >
        <div className='header'>
          {showTitle && <h3 className='header--item title line-clamp --3'>{data?.title}</h3>}
          {showBlurb && <small className='header--item blurb line-clamp --3'>{data?.blurb || ''}</small>}
        </div>

        <div className='footer'>
          {!!conditionBadge && (
            <div className='footer--item badge'>
              <small className='text-excerpt-1'>{conditionBadge}</small>
            </div>
          )}

          {showTimeAgo && (
            <div className='footer--item time-ago'>
              <small> {timeAgo(data?.published_at)}</small>
            </div>
          )}
          {showPublishDate && (
            <div className='footer--item date-publish'>
              <small>
                <FaRegCalendarAlt size={10} className='date-publish--icon' />
                {data?.published_at && useDateUpdate(data.published_at)}
              </small>
            </div>
          )}
        </div>
      </CardContent>
    </CardWrapper>
  );
};

const CardWrapper = styled.div`
  cursor: pointer;
  position: relative;
  display: grid;
  width: 100%;
  min-height: 80px;

  grid-template-columns: ${({ showImage }) => (showImage ? '3fr 7fr' : '1fr')};
  column-gap: 10px;

  @media (max-width: 1300px) {
    grid-template-columns: ${({ showImage }) => (showImage ? '3fr 5fr' : '1fr')};
  }
  @media (max-width: 1024px) {
    grid-template-columns: ${({ showImage }) => (showImage ? '2fr 3fr' : '1fr')};
  }
  @media (max-width: 768px) {
    grid-template-columns: ${({ showImage }) => (showImage ? '1fr 3fr' : '1fr')};
  }
  @media (max-width: 620px) {
    grid-template-columns: ${({ showImage }) => (showImage ? '1fr 2fr' : '1fr')};
  }
  @media (max-width: 425px) {
    grid-template-columns: ${({ showImage }) => (showImage ? '1fr 1fr' : '1fr')};
  }
  &:hover {
    img {
      transform: scale(1.1);
    }
    .title {
      color: #0600E7;
    }
  }
`;

const CardImage = styled.div`
  position: relative;
  overflow: hidden;
  padding: 0;
  margin: 0;

  img {
    display: block;
    width: 100%;
    max-height: 200px;
    aspect-ratio: 16/9;
    object-fit: cover;
    object-position: center;
  }
  .resolution-image {
    display: flex;
    box-shadow: 0px 0px 2px 0px #b7b7b7;
  }
`;

const CardContent = styled.a`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  color: #000;
  .header {
    margin-bottom: 8px;
    &--item {
      &:not(:last-child) {
        margin-bottom: 8px;
      }
    }

    .title {
      /* font-family: 'Nunito Sans', sans-serif !important; */
      text-transform: capitalize;
      font-size: 16px;
      font-weight: 400;
      line-height: 1.3;
      transition: all 0.5s ease-in-out;

      @media (max-width: 380px) {
        font-size: 14px;
      }
    }

    .blurb {
      /* font-family: 'Nunito Sans', sans-serif !important; */
      text-transform: capitalize;
      font-size: 12px;
      line-height: 1.25;

      color: #939393;

      @media (max-width: 767px) {
        font-size: 10px;
        line-height: 1;
      }
    }
  }

  .footer {
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    line-height: 0.2;
    padding-right: 5px;

    &--item {
      &:not(:last-child) {
        margin-right: 12px;
      }
    }
    .badge,
    .subscribe {
      background: #0600E7;
      padding: 5px 15px;
      border-radius: 50px;
      small {
        /* font-family: 'Nunito Sans', sans-serif; */
        text-transform: capitalize;
        font-size: 14px;
        line-height: 1;
        font-weight: 400;
        color: #fff;
        @media (max-width: 767px) {
          font-size: 12px;
        }
      }
    }
    .subscribe {
      display: flex;
      align-items: center;
      justify-content: space-between;

      padding: 5px 10px;

      /* small {
        color: #fff;
      } */
      svg {
        margin-right: 5px;
      }
      small,
      svg {
        color: #fff;
      }
      &:hover {
        background: #5d5d5d;
      }
    }
    .time-ago,
    .date-publish,
    .count-view {
      &--icon {
        margin-right: 4px;
      }
      &--icon,
      small {
        /* font-family: 'Nunito Sans', sans-serif !important; */
        text-transform: lowercase;
        font-size: 12px;
        font-weight: 200;
        line-height: 1;

        color: #939393;
      }
    }
  }
`;

export default memo(CardHSubscribe);
